module.exports = __webpack_public_path__ + "img/help_hover.0f2b2a7b.svg";